import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MerchCardGridLayout } from 'pricing-pages-ui-components/layouts/merch-cards/MerchCardGridLayout';
import { HsocMerchCard } from './merch-card-grid/HsocMerchCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GRID_AREA_NAMES = ['Title', 'Subheading', 'Pricing', 'CTAs', 'Features', 'Footer'];
export const HsocV2PricingPage = ({
  card
}) => {
  return /*#__PURE__*/_jsxs(View, {
    padding: "800",
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocPricingPage.title"
    }), card ? /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      maxInlineSize: "350px",
      children: /*#__PURE__*/_jsx(MerchCardGridLayout, {
        gridAreaNames: GRID_AREA_NAMES,
        gridAutoColumns: "minmax(0, 1fr)",
        children: /*#__PURE__*/_jsx(HsocMerchCard, Object.assign({
          columnStart: 1
        }, card))
      })
    }) : null]
  });
};